<template>
  <v-layout class="number-picker ma-0">
    <span
      :class="{ 'btn-disabled': disabled || value <= min }"
      class="btn"
      @click="decrease"
    >
      -
    </span>
    <v-flex class="pa-0">
      <input
        :value="value"
        :disabled="disabled"
        type="number"
        :min="min"
        :max="max"
        @input="handleInput"
        @blur="validateInput"
      >
    </v-flex>
    <span
      :class="{ 'btn-disabled': disabled || value >= max }"
      class="btn"
      @click="increase"
    >
      +
    </span>
    <span
      v-if="showMax"
      class="ml-2 caption grey--text"
    >
      /{{ max }}
    </span>
  </v-layout>
</template>

<script>
export default {
  name: 'QuantitySelector',
  props: {
    value: {
      type: Number,
      required: true
    },
    min: {
      type: Number,
      default: 1
    },
    max: {
      type: Number,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    showMax: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    handleInput (event) {
      const numValue = parseInt(event.target.value) || this.min
      this.emitChange(numValue)
    },
    validateInput () {
      let newValue = this.value
      if (newValue < this.min) {
        newValue = this.min
      } else if (newValue > this.max) {
        newValue = this.max
      }
      if (newValue !== this.value) {
        this.emitChange(newValue)
      }
    },
    increase () {
      if (!this.disabled && this.value < this.max) {
        this.emitChange(this.value + 1)
      }
    },
    decrease () {
      if (!this.disabled && this.value > this.min) {
        this.emitChange(this.value - 1)
      }
    },
    emitChange (value) {
      this.$emit('input', value)
      this.$emit('change', value)
    }
  }
}
</script>

<style lang="postcss" scoped>
.number-picker {
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  width: 100px;
  overflow: hidden;

  .btn {
    cursor: pointer;
    font-size: 14px;
    font-weight: 600;
    line-height: 24px;
    height: 24px;
    width: 24px;
    text-align: center;
    user-select: none;
    background-color: #f8f8f8;
    transition: all 0.2s ease;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  .btn:hover:not(.btn-disabled) {
    background-color: #e8e8e8;
    color: #1976d2;
  }

  .btn:active:not(.btn-disabled) {
    background-color: #d0d0d0;
    transform: scale(0.95);
  }

  .btn-disabled {
    cursor: not-allowed;
    color: #bbb;
    background-color: #f5f5f5;
  }

  input {
    width: 100%;
    line-height: 24px;
    height: 24px;
    vertical-align: middle;
    text-align: center;
    border: none;
    outline: none;
    background-color: white;
    font-weight: 500;
    font-size: 13px;
    color: #333;
  }

  input:disabled {
    background-color: #f5f5f5;
    color: #bbb;
    cursor: not-allowed;
  }

  input:focus {
    background-color: #fafafa;
  }

  /* 隐藏数字输入框的箭头 */
  input[type="number"]::-webkit-outer-spin-button,
  input[type="number"]::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  input[type="number"] {
    appearance: textfield;
    -moz-appearance: textfield;
  }
}
</style>
